module.exports = __webpack_public_path__ + "img/hole-crosshair.dafce7eb.png";